import { MY_LIFESTYLE } from '../constants';
import { LIFESTYLE } from '../constants/progressCategories';

const myLifestyleHydration = {
  name: 'hydration',
  category: MY_LIFESTYLE,
  progressCategory: LIFESTYLE,
  route: `/consultation/${MY_LIFESTYLE}/hydration`,
  title: 'How much water do you drink every day? ',
  tip: {
    title: 'fun fact no. 999',
    content: `Fun fact: Hair is 10% water! Water is found in every layer of the hair's structure, and is essential for its strength, elasticity and damage-resistance, as well as scalp health. If you're reading this, refill your glass.`,
  },
  options: [
    {
      value: 'less_than_3_glasses',
      label: 'Less than 3 glasses',
    },
    {
      value: '4_6_glasses',
      label: '4 - 6 glasses (1 liter)',
    },
    {
      value: '7_8_glasses',
      label: '7 - 8 glasses (1.5 liters)',
    },
    {
      value: 'more_than_8_glasses',
      label: 'More than that',
    },
  ],
  shouldBeIncluded: () => true,
  getInitialValue: answers => answers.profile_hydration,
  getAnswers: ({ selected }) => ({ profile_hydration: selected }),
};

export default myLifestyleHydration;
